import {AlertColor, Snackbar, Typography} from '@mui/material'
import {useEffect, useState} from 'react'
import {PaginationType} from 'src/components/elements/TableCustom/TableCustom'
import EnrollmentPatientTable from 'src/components/templates/EnrollmentPatientTable/EnrollmentPatientTable'
import apiClient from 'src/services/apiClient'
import {PatientEnrollmentStyled} from './PatientEnrollmentStyled'
import SnackbarAlertCustom from 'src/components/elements/SnackbarAlertCustom/SnackbarAlertCustom'
import NewPatientEnrollmentDialog from 'src/components/templates/NewPatientEnrollmentDialog/NewPatientEnrollmentDialog'
import {STATUS} from 'src/constants/constants'

const PatientEnrollment = () => {
  const [status, setStatus] = useState<string | undefined>()
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [severity, setSeverity] = useState<AlertColor>('success')
  const [message, setMessage] = useState('')
  const [filters, setFilters] = useState([])
  const [fetchedData, setFetchedData] = useState<{data: Record<string, any>[], count: number}>({
    data: [],
    count: 0
  })
  const [isNewPatientEnrollmentModal, setIsNewPatientEnrollmentModal] = useState<boolean>(false)
  const [selectedRequest, setSelectedRequest] = useState<Record<string, any> | undefined>(undefined)
  const [pagination, setPagination] = useState<PaginationType>({
    page: 0,
    rowsPerPage: 10,
    order: '-createdAt'
  })

  const submitForm = async (values: any) => {
    const {firstName, lastName, birthDate, file: fileList} = values
    const formData = new FormData()
    formData.append('firstName', firstName)
    formData.append('lastName', lastName)
    formData.append('birthDate', birthDate.toISOString())
    fileList.forEach(({originFileObj}: any) => {
      formData.append('file', originFileObj, originFileObj.name)
    })
    await apiClient.postPatientEnrollment(formData, setStatus)
    fetchData()
    setIsNewPatientEnrollmentModal(false)
  }

  const onSubmitFilter = (values: any) => {
    setFilters(values)
    setPagination(prev => ({...prev, page: 0}))
  }

  const fetchData = async () => {
    Promise.all([apiClient.getPatientEnrollmentRequest(filters, setStatus, pagination), apiClient.getPatientEnrollmentRequestCount(filters, setStatus)])
      .then(([exports, count]) => {
        setFetchedData({
          data: exports,
          count
        })
      })
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  useEffect(() => {
    if (status === STATUS.REJECTED) {
      setSeverity('error')
      setMessage('Si è verificato un errore')
      setOpenSnackbar(true)
    }
  }, [status])

  return (
    <>
      <Snackbar
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        onClose={() => setOpenSnackbar(false)}
        open={openSnackbar}
      >
        <div>
          <SnackbarAlertCustom onClose={() => setOpenSnackbar(false)} severity={severity} sx={{width: '100%'}}>
            <Typography variant='h5'>
              {message}
            </Typography>
          </SnackbarAlertCustom>
        </div>
      </Snackbar>
      <PatientEnrollmentStyled>
        <EnrollmentPatientTable fetchedData={fetchedData} onSubmitFilter={onSubmitFilter} pagination={pagination} setIsNewPatientEnrollmentModal={setIsNewPatientEnrollmentModal} setPagination={setPagination} setSelectedRequest={setSelectedRequest} />
      </PatientEnrollmentStyled>
      {isNewPatientEnrollmentModal &&
        <NewPatientEnrollmentDialog
          onClose={() => setIsNewPatientEnrollmentModal(false)}
          onSubmit={(values) => submitForm(values)}
          request={selectedRequest}
        />}
    </>
  )
}

export default PatientEnrollment
